module.exports = __webpack_public_path__ + "img/Magno2.270a18c8.jpg";